<div class="questionnaire-field-spacer-no-width d-flex flex-column">
    <p-selectbutton
            [options]="props.selectButtonOptions"
            [formControl]="$any(formControl)"
            [multiple]="props.isMultiple"
            [ngClass]="props.variant"
            optionLabel="label"
            optionValue="value"
            aria-labelledby="basic"
    >
        <ng-template #item let-item>
            <div class="d-flex align-items-center gap-2">
                {{item.label}}
                <app-tooltip
                        *ngIf="item.tooltip"
                        [tooltip]="item.tooltip"></app-tooltip>
            </div>

        </ng-template>
    </p-selectbutton>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />

</div>
